import {h5ObtainProfile, h5ObtainAccessToken} from '../hybrid';
import {getQueryString} from '@activity-business/h5-package-frameworkTool';

interface BlockItem {
    p: Promise<string>;
    r: (value: any) => void;
}
class GetToken {
    token?: string;
    block: BlockItem[] = [];
    constructor(){}
    // 通过 jsBridge 与 app 交互获取 token
    async getAppToken(selfItem: BlockItem){
        const asyncToken = await h5ObtainAccessToken().then(({access_token}) => {
            if(access_token){
                this.token = access_token;
                // 成功获取 token 后释放所有阻塞 promise
                this.block.forEach(item => item.r(access_token));
            };
            return access_token;
        }).catch(async error => {
            // 获取失败后只释放当前请求的 promise
            const selfIndex = this.block.findIndex(item => item == selfItem);
            this.block.splice(selfIndex, 1);
            selfItem.r('获取失败');
            const baseInfo = {
                userAgent: window.navigator.userAgent,
                activityName: window.location.pathname,
            };
            const errJSON = await h5ObtainProfile().then(profile => {
                const otherInfo = {uid: profile.user.uid, error_token: error.toString()};
                return JSON.stringify(Object.assign(baseInfo, otherInfo));
            })
            .catch(error => JSON.stringify(Object.assign({error_profile: error.toString()}, baseInfo)));
            
            // /***** 利用 catch 无法捕获异步报错来抛出错误，从而被 sentry 收集 *****/
            // setTimeout(() => {
            //     let isOpLink = /_op/.test(window.location.pathname);
            //     // 非运营位 _op 抛出异常捕获
            //     if (!isOpLink) {
            //         throw new Error(`获取 token 失败：${errJSON}`);
            //     }
            // })

            /***** 获取 token 失败直接抛出错误 *****/
            throw new Error(`获取 token 失败：${errJSON}`)
        });

        return asyncToken;
    }
    getSyncToken(){
        let syncToken = getQueryString('key');
        if(syncToken) this.token = syncToken;
        return syncToken;
    }
    async getToken (){
        const {block, token} = this;
        if(token) return token;
        // 同步获取
        if(this.getSyncToken()) return this.getSyncToken();

        let r: BlockItem['r'] = () => {};
        let p: BlockItem['p'] = new Promise(res => r = res);
        const item = {p, r};

        const lastPromise = this.block.slice(-1)[0];
        this.block.push(item);
        if(lastPromise) await lastPromise.p;
        // 通过 promise 阻塞后，前一个获取请求成功获取并设置 this.token 值，此时直接返回 this.token
        if(this.token) return this.token;
        //	获取异步 token
        const asyncToken = await this.getAppToken(item);
        return asyncToken;
    }
};

const instance = new GetToken();

export default instance.getToken.bind(instance);


